module.exports = __webpack_public_path__ + "static/media/howLoveWorks.1d6845bb.png";